
















/* Created- 24 - Apr - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";

@Component(
	{
		name: "ParticaFullDialog",
		components: {}
	})
export default class ParticaFullDialog extends Vue {
	@Prop() private title: string; // your data
	@Prop() private value: boolean;
}
